var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContentActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 2.25C8.08579 2.25 7.75 2.58579 7.75 3C7.75 3.41421 8.08579 3.75 8.5 3.75H16.5C16.9142 3.75 17.25 3.41421 17.25 3C17.25 2.58579 16.9142 2.25 16.5 2.25H8.5Z",
    fill: "#FD8A24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 6.25C6.08579 6.25 5.75 6.58579 5.75 7C5.75 7.41421 6.08579 7.75 6.5 7.75H18.5C18.9142 7.75 19.25 7.41421 19.25 7C19.25 6.58579 18.9142 6.25 18.5 6.25H6.5Z",
    fill: "#FD8A24"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 10.25C4.98122 10.25 3.75 11.4812 3.75 13V19C3.75 20.5188 4.98122 21.75 6.5 21.75H18.5C20.0188 21.75 21.25 20.5188 21.25 19V13C21.25 11.4812 20.0188 10.25 18.5 10.25H6.5ZM11.3354 13.3292C11.1029 13.2129 10.8268 13.2254 10.6057 13.362C10.3846 13.4987 10.25 13.7401 10.25 14V18C10.25 18.2599 10.3846 18.5013 10.6057 18.638C10.8268 18.7746 11.1029 18.7871 11.3354 18.6708L15.3354 16.6708C15.5895 16.5438 15.75 16.2841 15.75 16C15.75 15.7159 15.5895 15.4562 15.3354 15.3292L11.3354 13.3292Z",
    fill: "#FD8A24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentActive);
export default __webpack_public_path__ + "static/media/content-active.cb6df62df5f202becbe92fa28a42865e.svg";
export { ForwardRef as ReactComponent };